import { Button, Grid } from "@material-ui/core";
import * as React from "react";

const StepperControlFooter = (props) => {
  const {
    disabled,
    disableNext,
    onCancel,
    onBack,
    onNext,
    stepper,
    submitText,
    onSubmit,
    ...rest
  } = props;
  const showSubmit = stepper.current === stepper.config.steps - 1;
  return (
    <Grid container spacing={2} justifyContent={onCancel ? "flex-start" : "flex-end"} {...rest}>
      {onCancel && (
        <Grid item>
          <Button onClick={onCancel}>Cancel</Button>
        </Grid>
      )}
      {onCancel && <div style={{ flexGrow: 1 }}/>}
      <Grid item>
        <Button
          type="button"
          variant="text"
          color="default"
          onClick={onBack}
          disabled={stepper.current === 0}
        >
          Back
        </Button>
      </Grid>
      <Grid item>
        {showSubmit && (
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={disableNext || disabled}
            onClick={onSubmit}
          >
            {submitText || "Submit"}
          </Button>
        )}
        {!showSubmit && (
          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={onNext}
            disabled={disableNext || disabled}
          >
            Next
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export { StepperControlFooter };
